import React, { useEffect, useState } from "react";
import QuestionMark from "../../../assets/Icon/QuestionMark";
import CustomInput from "../../UI/CustomInput";
import ToggleSwitchButton from "../../UI/ToggleSwitchButton";
import { v4 as uuidv4 } from "uuid";
import cs from "classnames";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TooltipButton from "../../UI/TooltipButton";
import { calculatorDataSelector } from "../../../redux/selectors/CalculatorSelectors";
import { useSelector } from "react-redux";
import { getParameterByName } from "../helper";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const StepThree = ({
  data,
  setData,
  calculatorType,
  handleBlur,
  dataError,
  setDataError,
  handleEnter,
}) => {
  console.log("data.activity", data.activity);
  const calculatorData = useSelector(calculatorDataSelector);
  const [isTimeBreakdown, setIsTimeBreakdown] = useState(
    data.activity.length > 0,
  );
  const calcId = getParameterByName("id");
  const handleChange = ({ target: { value } }) => {
    if (!value) {
      setDataError({
        ...dataError,
        timeYouSpend: { ...dataError.timeYouSpend, valueError: true },
      });
    } else {
      setDataError({
        ...dataError,
        timeYouSpend: { ...dataError.timeYouSpend, valueError: false },
      });
    }
    setData({ ...data, timeYouSpend: { ...data.timeYouSpend, value } });
  };
  const handleTime = (time) => {
    setData({ ...data, timeYouSpend: { ...data.timeYouSpend, time } });
  };
  const handleChangeActivity = (value, id, key) => {
    const updateData = data.activity.map((val) => {
      if (val.id === id) {
        return {
          ...val,
          [key]: value,
        };
      }
      return { ...val };
    });
    setData({ ...data, activity: updateData });
  };

  const handleAddActivity = () => {
    setData({
      ...data,
      activity: [
        ...data.activity,
        { id: uuidv4(), name: "", time: "hours", value: "" },
      ],
    });
  };

  useEffect(() => {
    const selectedCalc = calculatorData.data.find((val) => val._id === calcId);
    if (selectedCalc) {
      setIsTimeBreakdown(selectedCalc.timeBreakName.length > 0);
    }
  }, [calculatorData.data]);

  return (
    <div>
      <p className="mt-5 mb-0">
        How much time did you spend producing the product, packaging, and
        shipping it?
        <TooltipButton
          title="Ex: You spent a total of 30 minutes producing your homemade candle from start (acquiring materials) to finish (packaging and mailing it)."
          placement="top"
          icon={<QuestionMark />}
        />
      </p>

      <div className="d-flex align-items-center">
        <CustomInput
          formControlClass="time-input"
          type="number"
          placeholder="0"
          value={data.timeYouSpend.value}
          onChange={handleChange}
          autoFocus
          min="0"
          onKeyPress={handleEnter}
          onBlur={handleBlur}
          disabled={isTimeBreakdown}
          className={cs({
            ["error-input"]: dataError.timeYouSpend.valueError,
          })}
        />
        <ToggleSwitchButton
          value={data.timeYouSpend.time}
          className="ml-3 toggle-btn-wrapper"
          onChange={handleTime}
          disabled={isTimeBreakdown}
        />
      </div>

      <div className="position-relative mt-5">
        <hr className="calculator-hr-line" />
        <span className="hr-center-label position-absolute text-center">
          Or
        </span>
      </div>

      <FormControlLabel
        className="breakdown-text"
        control={
          <Checkbox
            checked={isTimeBreakdown}
            onChange={() => {
              setIsTimeBreakdown(!isTimeBreakdown);
              setData({
                ...data,
                timeYouSpend: { ...data.timeYouSpend, value: "" },
                activity: [],
              });
            }}
          />
        }
        label={
          <>
            Enter your own time breakdown
            <TooltipButton
              title="Ex: You spent 15 minutes making your candle and 15 minutes packaging and shipping it."
              placement="top"
              icon={<QuestionMark />}
            />
          </>
        }
      />

      {isTimeBreakdown && (
        <>
          {data.activity.map((a, i) => (
            <div className="time_breakdown_wrapper" key={i}>
              <CustomInput
                placeholder="Name of activity"
                formControlClass="activity-input"
                type="text"
                value={a.name}
                onChange={({ target: { value } }) => {
                  handleChangeActivity(value, a.id, "name");
                }}
              />
              <div className="d-flex align-items-center justify-content-center">
                <CustomInput
                  placeholder="0"
                  wrapperClasses="time_breakdown_input_wrapper"
                  formControlClass="time-input ml-5 activity-time"
                  type="number"
                  min="0"
                  value={a.value}
                  onChange={({ target: { value } }) => {
                    handleChangeActivity(value, a.id, "value");
                  }}
                />
                <ToggleSwitchButton
                  className="ml-3 toggle-btn-wrapper"
                  value={a.time}
                  onChange={(val) => handleChangeActivity(val, a.id, "time")}
                />
              </div>
            </div>
          ))}
          <div className="mt-4 extra-link">
            <span
              className="text-decoration-underline pointer-cursor"
              onClick={handleAddActivity}
            >
              + Add additional activity
            </span>
          </div>
        </>
      )}
    </div>
  );
};
export default StepThree;
